export default "__VITE_ASSET__CoV7S8xM__"